export default __webpack_public_path__ + "static/media/left-angle.c27be648.svg";